import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { TabBar } from '@/components/layout/TabBar';
import { CommandMenu } from '@/components/layout/CommandMenu';
import { ReadyNotice } from '@/components/projects/ReadyNotice';
import { SideRail } from '@/components/layout/SideRail';
import { useToolCatalog } from '@/lib/tool-catalog';
import { PaySheet } from '@/components/pay/PaySheet';

// The parts of the frame that live outside any one page (Studio Blueprint
// 02/03): the phone tab bar, the desktop left menu and the command menu. Every
// route gets them except the phone half of FaceLock Scan (a single-purpose
// camera screen) and a shared living cover (/cover/<id>, full screen: the
// link a customer posts); the Reel (/watch) is full screen, so it has no left menu.
// The ready notice ("your render is ready", 2026-10-16) rides along with them.
const BARE_PATHS = ['/facelock-scan', '/cover/'];
const NO_RAIL_PATHS = ['/facelock-scan', '/watch', '/cover/'];

export function ShellChrome() {
  const { pathname } = useLocation();
  const [commandOpen, setCommandOpen] = useState(false);
  const bare = BARE_PATHS.some((p) => pathname.startsWith(p));
  const rail = !NO_RAIL_PATHS.some((p) => pathname.startsWith(p));
  // On a tool's own page the left menu folds to a slim strip, the tool gets the room (owner 2026-10-18).
  const catalog = useToolCatalog();
  const onTool = catalog.some((cat) => cat.tools.some((tool) => tool.path !== '/' && (pathname === tool.path || pathname.startsWith(`${tool.path}/`))));
  const mini = rail && onTool;

  // The page leaves room for the tab bar (index.css .has-tabbar) and the left menu, whole or folded.
  useEffect(() => {
    document.body.classList.toggle('has-tabbar', !bare);
    document.body.classList.toggle('has-siderail', rail && !mini);
    document.body.classList.toggle('has-siderail-mini', mini);
    return () => document.body.classList.remove('has-tabbar', 'has-siderail', 'has-siderail-mini');
  }, [bare, rail, mini]);

  return (
    <>
      {!bare && <TabBar />}
      {rail && <SideRail mini={mini} />}
      <CommandMenu open={commandOpen} onOpenChange={setCommandOpen} />
      {!bare && <ReadyNotice />}
      <PaySheet />
    </>
  );
}
